import type { TListQuery, TRange, TSortDirection } from './api.types';

const DEFAULT_PER_PAGE = 25;

const DEFAULT_LIST_QUERY: TListQuery = {
  page: 1,
  perPage: DEFAULT_PER_PAGE,
};

const ESCAPED_FILTER_CHARS = /[%_,().\\]/g;

const toRange = ({ page, perPage }: TListQuery): TRange => {
  const from = Math.max(page - 1, 0) * perPage;

  return { from, to: from + perPage - 1 };
};

const toAscending = (direction: TSortDirection = 'desc'): boolean => direction === 'asc';

const toSearchTerm = (search: string): string => search.trim().replace(ESCAPED_FILTER_CHARS, '');

const toSearchFilter = (columns: readonly string[], search: string): string => {
  const term = toSearchTerm(search);

  return columns.map(column => `${column}.ilike.%${term}%`).join(',');
};

const toPageCount = (total: number, perPage: number): number => {
  if (perPage <= 0) {
    return 0;
  }

  return Math.ceil(total / perPage);
};

export {
  DEFAULT_LIST_QUERY,
  DEFAULT_PER_PAGE,
  toAscending,
  toPageCount,
  toRange,
  toSearchFilter,
  toSearchTerm,
};
